/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'underscore'
], function (
	_
) {
	/**
	 * Most of Dashboard references the board and widget specs using APIs - but processing on the raw specs before they are deserialized into APIs don't have this advantage. 
	 * This utility encapsulates operations which one may be tempted to hand craft, allowing for them to updated in one place, as a poor man's alternative to an API.
	 */
	class DashboardSpecUtil {

		/**
		 * @param {object} layout - a layout from a board spec
		 * @return {object[]} the widget models in the given layout
		 */
		static getWidgetModelList(layout) {
			return DashboardSpecUtil.getWidgetList(layout)
				.map( ({ model }) => model);
		}

		/**
		 * @param {object} layout - a layout from a board spec
		 * @returns {object[]} for each widget, its `model` and `properties`
		 */
		static getWidgetList(layout) {
			return DashboardSpecUtil._getWidgetList(layout)
				.map(
					widget => ({
						model: DashboardSpecUtil._getWidgetModel(widget),
						properties: DashboardSpecUtil._getWidgetProperties(widget)
					})
				).filter(
					({ model }) => !!model
				);
		}

		static _getWidgetList(layout) {
			let layouts = [];
			if (layout.type === 'widget') {
				//This layout is a widget - return it
				layouts.push(layout);
			}

			if (layout.items) {
				//Recursively search for widget layouts
				layouts = _.flatten(
					[
						layouts,
						layout.items.map(item => DashboardSpecUtil._getWidgetList(item))
					]
				);
			}
			return layouts;
		}

		static _getWidgetModel(widget) {
			return widget && widget.features && widget.features.Models_internal;
		}

		static _getWidgetProperties(widget) {
			return (widget && widget.properties) || {};
		}

	}

	return DashboardSpecUtil;
});
